import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import withMatch from '@/hocs/withMatch';
import withApiData from '../services/withApiData';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
import Link from '@/components/atoms/Link';
import LockIcon from './shared/icons/Key';
import Caret from './shared/icons/Caret';
import PlaceholderUser from './shared/icons/PlaceholderUser';
import PlaceholderUserCJ from './shared/icons/PlaceholderUserCJ';
import SettingsIcon from './shared/icons/Profile';
import LoginIcon from './shared/icons/Logout';
import { colorPalette, fonts } from '../styles/styleGuide';
import { darken } from '../styles/utils';
import CalendarIcon from './shared/icons/Actions';
import MailIcon from './shared/icons/Message';
import FolderIcon from './shared/icons/Documents';
import AlertIcon from './shared/icons/Notification';
import HouseIcon from './shared/icons/HouseBase';
import { performApiRequest, getResultData, getApiDataRequest, clearCache } from '../redux/apiData';
import { updateMobileMenuState } from '../redux/menu';
import { openModal } from '../redux/modal';
import get from 'lodash.get';
import countNotifications from '../services/countNotifications';
var connectApiData = withApiData({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    notifications: getResultData(state.apiData, 'getNotifications', {
      projectSlug: String(ownProps.match.params.projectSlug)
    }),
    activationPossible: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'activationPossible', false),
    logoutUserRequest: getApiDataRequest(state.apiData, 'logoutUser')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNotifications: function getNotifications(projectSlug) {
      dispatch(performApiRequest('getNotifications', {
        projectSlug: projectSlug
      }));
    },
    onNavigate: function onNavigate() {
      dispatch(updateMobileMenuState(false));
    },
    onLogout: function onLogout(projectSlug) {
      var _ownProps$router;
      dispatch(performApiRequest('logoutUser'));
      dispatch(clearCache());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat(projectSlug, "/closed"));
    },
    openActivationModal: function openActivationModal(activationType) {
      dispatch(openModal(colorPalette.lightOrange, activationType));
    }
  };
};
var MobileLoginBarProfile = /*#__PURE__*/function (_Component) {
  function MobileLoginBarProfile() {
    var _this;
    _classCallCheck(this, MobileLoginBarProfile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MobileLoginBarProfile, [].concat(args));
    _defineProperty(_this, "refMap", {});
    _defineProperty(_this, "state", {
      expanded1: false,
      expanded2: false
    });
    _defineProperty(_this, "activation", function () {
      var props = _this.props;
      props.openActivationModal({
        type: 'activation',
        componentProps: {}
      });
      props.onNavigate();
    });
    _defineProperty(_this, "handleClick", function () {
      var props = _this.props;
      props.onNavigate();
      props.onLogout(String(props.match.params.projectSlug));
    });
    _defineProperty(_this, "openMenu", function (phase) {
      var subNavMaxHeight = _this.refMap[phase].offsetHeight;
      _this.setState(function (prevState) {
        return _defineProperty({}, 'subNavMaxHeight_' + phase, subNavMaxHeight);
      });
      if (phase === 'cj1') {
        _this.setState({
          expanded1: !_this.state.expanded1
        });
      } else {
        _this.setState({
          expanded2: !_this.state.expanded2
        });
      }
    });
    _defineProperty(_this, "getSubNavMaxHeight", function (state, phase) {
      return state['subNavMaxHeight_' + phase];
    });
    return _this;
  }
  _inherits(MobileLoginBarProfile, _Component);
  return _createClass(MobileLoginBarProfile, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        settings = _this$props.settings,
        match = _this$props.match,
        logoutUserRequest = _this$props.logoutUserRequest,
        getNotifications = _this$props.getNotifications;
      if ((settings.phase === 'cj2' || settings.phase === 'cj3') && !logoutUserRequest) {
        getNotifications(String(match.params.projectSlug));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        profile = _this$props2.profile,
        notifications = _this$props2.notifications,
        match = _this$props2.match,
        settings = _this$props2.settings,
        onNavigate = _this$props2.onNavigate,
        activationPossible = _this$props2.activationPossible;
      var _this$state = this.state,
        expanded1 = _this$state.expanded1,
        expanded2 = _this$state.expanded2;
      var profileData = profile.data;
      var projectSlug = match.params.projectSlug;
      var imageUrl = settings.phase === 'cj1' ? get(profileData, 'image', undefined) : get(profileData, 'customer.customerImage') ? get(profileData, 'customer.customerImage') : get(profileData, 'image', undefined);
      return profileData ? __jsx(LoggedIn, {
        "data-id": "components_MobileLoginBarProfile_LoggedIn"
      }, (settings.phase === 'cj2' || settings.phase === 'cj3') && notifications && __jsx(LoginItem, {
        "data-id": "components_MobileLoginBarProfile_LoginItem"
      }, __jsx(HoverButton, {
        onClick: function onClick() {
          return _this2.openMenu('cj2');
        },
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj2'),
        expanded: expanded2,
        "data-id": "components_MobileLoginBarProfile_HoverButton"
      }, __jsx(NotifyIconWrapper, {
        "data-id": "components_MobileLoginBarProfile_NotifyIconWrapper"
      }, __jsx(AlertIcon, {
        color: colorPalette.white,
        width: 21,
        height: 21,
        "data-id": "components_MobileLoginBarProfile_AlertIcon"
      }), countNotifications(notifications) > 0 && __jsx(NotifyNumber, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumber"
      }, countNotifications(notifications)), "Notificaties"), __jsx(CaretContainer, {
        expanded: expanded2,
        "data-id": "components_MobileLoginBarProfile_CaretContainer"
      }, __jsx(Caret, {
        direction: "down",
        color: colorPalette.white,
        width: 10,
        height: 6,
        "data-id": "components_MobileLoginBarProfile_Caret"
      }))), __jsx(HoverMenuContainer, {
        expanded: expanded2,
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj2'),
        "data-id": "components_MobileLoginBarProfile_HoverMenuContainer"
      }, __jsx("div", {
        ref: function ref(input) {
          _this2.refMap['cj2'] = input;
        },
        "data-id": "components_MobileLoginBarProfile_div"
      }, __jsx(HoverMenu, {
        "data-id": "components_MobileLoginBarProfile_HoverMenu"
      }, notifications.messages && __jsx(ListLoginItem, {
        href: "/".concat(getLinkFromPageObject(notifications.messages.link)),
        color: colorPalette.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(MailIcon, {
        color: colorPalette.beige,
        width: 21,
        height: 15,
        "data-id": "components_MobileLoginBarProfile_MailIcon"
      }), notifications.messages.unreadCount > 0 && __jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.messages.unreadCount)), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Ongelezen berichten")), notifications.documents && __jsx(ListLoginItem, {
        href: "/".concat(getLinkFromPageObject(notifications.documents.link)),
        color: colorPalette.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(FolderIcon, {
        color: colorPalette.beige,
        width: 21,
        height: 21,
        "data-id": "components_MobileLoginBarProfile_FolderIcon"
      }), notifications.documents.unreadCount > 0 && __jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.documents.unreadCount)), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Nieuwe documenten")), notifications.actions && __jsx(ListLoginItem, {
        href: "/".concat(getLinkFromPageObject(notifications.actions.link)),
        color: colorPalette.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(CalendarIcon, {
        color: colorPalette.beige,
        width: 22,
        height: 22,
        "data-id": "components_MobileLoginBarProfile_CalendarIcon"
      }), notifications.actions.unreadCount > 0 && __jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.actions.unreadCount)), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Acties in planning")), notifications.newOptions && __jsx(ListLoginItem, {
        href: "/".concat(getLinkFromPageObject(notifications.newOptions.link)),
        color: colorPalette.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(HouseIcon, {
        color: colorPalette.beige,
        width: 22,
        height: 22,
        "data-id": "components_MobileLoginBarProfile_HouseIcon"
      }), notifications.newOptions.unreadCount > 0 && __jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.newOptions.unreadCount)), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Nieuwe opties")), notifications.ordersToConfirm && __jsx(ListLoginItem, {
        href: "/".concat(getLinkFromPageObject(notifications.ordersToConfirm.link)),
        color: colorPalette.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(HouseIcon, {
        color: colorPalette.beige,
        width: 22,
        height: 22,
        "data-id": "components_MobileLoginBarProfile_HouseIcon"
      }), notifications.ordersToConfirm.unreadCount > 0 && __jsx(NotifyNumberHover, {
        "data-id": "components_MobileLoginBarProfile_NotifyNumberHover"
      }, notifications.ordersToConfirm.unreadCount)), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Orders ter bevestiging")))))), __jsx(LoginItem, {
        "data-id": "components_MobileLoginBarProfile_LoginItem"
      }, __jsx(HoverButton, {
        onClick: function onClick() {
          return _this2.openMenu('cj1');
        },
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj1'),
        expanded: expanded1,
        "data-id": "components_MobileLoginBarProfile_HoverButton"
      }, __jsx(UserDetails, {
        "data-id": "components_MobileLoginBarProfile_UserDetails"
      }, __jsx(UserImage, {
        "data-id": "components_MobileLoginBarProfile_UserImage"
      }, imageUrl && __jsx(BackgroundImage, {
        image: imageUrl,
        "data-id": "components_MobileLoginBarProfile_BackgroundImage"
      }), !imageUrl && settings.phase === 'cj1' && __jsx(PlaceholderUser, {
        "data-id": "components_MobileLoginBarProfile_PlaceholderUser"
      }), !imageUrl && (settings.phase === 'cj2' || settings.phase === 'cj3') && __jsx(PlaceholderUserCJ, {
        "data-id": "components_MobileLoginBarProfile_PlaceholderUserCJ"
      })), settings.phase === 'cj1' ? profileData.name : settings.phase !== 'cj1' && profileData.customer && profileData.customer.customerName ? profileData.customer.customerName : profileData.name), __jsx(CaretContainer, {
        expanded: this.state.expanded1,
        "data-id": "components_MobileLoginBarProfile_CaretContainer"
      }, __jsx(Caret, {
        direction: "down",
        color: colorPalette.white,
        width: 10,
        height: 6,
        "data-id": "components_MobileLoginBarProfile_Caret"
      }))), __jsx(HoverMenuContainer, {
        expanded: expanded1,
        maxHeight: this.getSubNavMaxHeight(this.state, 'cj1'),
        "data-id": "components_MobileLoginBarProfile_HoverMenuContainer"
      }, __jsx("div", {
        ref: function ref(input) {
          _this2.refMap['cj1'] = input;
        },
        "data-id": "components_MobileLoginBarProfile_div"
      }, __jsx(HoverMenu, {
        "data-id": "components_MobileLoginBarProfile_HoverMenu"
      }, __jsx(ListLoginItem, {
        href: "/".concat(String(projectSlug), "/closed/profiel"),
        color: colorPalette.blue,
        onClick: onNavigate,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(SettingsIcon, {
        width: 18,
        height: 18,
        color: colorPalette.beige,
        "data-id": "components_MobileLoginBarProfile_SettingsIcon"
      })), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Profiel")), __jsx(ListLoginItem, {
        href: "/".concat(String(projectSlug), "/closed/"),
        onClick: this.handleClick,
        color: colorPalette.blue,
        "data-id": "components_MobileLoginBarProfile_ListLoginItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(LoginIcon, {
        width: 18,
        height: 18,
        color: colorPalette.beige,
        "data-id": "components_MobileLoginBarProfile_LoginIcon"
      })), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Uitloggen")), activationPossible && __jsx(ListItem, {
        color: colorPalette.blue,
        onClick: this.activation,
        "data-id": "components_MobileLoginBarProfile_ListItem"
      }, __jsx(IconWrapper, {
        "data-id": "components_MobileLoginBarProfile_IconWrapper"
      }, __jsx(LockIcon, {
        width: 18,
        height: 18,
        color: colorPalette.beige,
        "data-id": "components_MobileLoginBarProfile_LockIcon"
      })), __jsx("span", {
        "data-id": "components_MobileLoginBarProfile_span"
      }, "Activatiecode invoeren"))))))) : null;
    }
  }]);
}(Component);
export default withMatch(connectApiData(connect(mapStateToProps, mapDispatchToProps)(MobileLoginBarProfile)));
var LoggedIn = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var BackgroundImage = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n"])), function (props) {
  return props.image;
});
var UserDetails = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var LoginItem = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: #fff;\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n  border-bottom: 1px solid ", ";\n"])), fonts.primary, colorPalette.beige);
var HoverButton = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 233rem;\n  height: 42rem;\n  justify-content: space-between;\n  padding: 0 22rem 0 25rem;\n\n  ", ";\n"])), function (props) {
  return props.expanded ? "\n        background-color: ".concat(colorPalette.lightBlue, ";\n\n        &:hover {\n          background-color: ").concat(colorPalette.darkBlue, ";\n        }\n      ") : "\n      background-color: ".concat(colorPalette.headerGrey, ";\n\n      &:hover {\n        background-color: ").concat(darken(colorPalette.headerGrey, 15), ";\n      }\n  ");
});
var CaretContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 6rem;\n  transition: transform 0.2s ease-in-out;\n  transform: translateY(-50%) ", ";\n  transform-origin: center center;\n"])), function (props) {
  return props.expanded ? 'scaleY(-1)' : 'scaleY(1)';
});
var HoverMenuContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  max-height: ", "rem;\n  transition: max-height 0.22s ease-in-out;\n  -webkit-backface-visibility: hidden;\n  -webkit-transform-style: preserve-3d;\n  will-change: transform;\n  overflow: hidden;\n"])), function (props) {
  return props.expanded ? props.maxHeight : '0';
});
var HoverMenu = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  padding-left: 25rem;\n  padding-top: 4rem;\n  padding-bottom: 32rem;\n"])), colorPalette.lightGrey);
var NotifyNumberHover = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: -4rem;\n  bottom: -1rem;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 1px solid white;\n  width: 16rem;\n  height: 16rem;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12rem;\n  font-weight: bold;\n"])), colorPalette.orange);
var ListLoginItem = styled(Link)(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  display: flex;\n  line-height: 24rem;\n  cursor: pointer;\n  margin-top: 20rem;\n  position: relative;\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  > span {\n    position: relative;\n\n    &:hover {\n      &:after {\n        content: '';\n        position: absolute;\n        left: 0;\n        bottom: -5rem;\n        width: 100%;\n        height: 4rem;\n        background-color: ", ";\n        border-radius: 0 0 3rem 0;\n      }\n    }\n  }\n"])), colorPalette.textGrey, fonts.primary, NotifyNumberHover, colorPalette.darkOrange, function (props) {
  return props.color;
});
var ListItem = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  display: flex;\n  line-height: 24rem;\n  cursor: pointer;\n  margin-top: 20rem;\n  position: relative;\n\n  > span {\n    position: relative;\n\n    &:hover {\n      &:after {\n        content: '';\n        position: absolute;\n        left: 0;\n        bottom: -5rem;\n        width: 100%;\n        height: 4rem;\n        background-color: ", ";\n        border-radius: 0 0 3rem 0;\n      }\n    }\n  }\n"])), colorPalette.textGrey, fonts.primary, function (props) {
  return props.color;
});
var IconWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin-right: 12rem;\n  position: relative;\n  width: 25rem;\n"])));
var UserImage = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin-right: 8rem;\n  align-self: auto;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  background-color: ", ";\n  width: 24rem;\n  height: 24rem;\n  border-radius: 50%;\n\n  > div {\n    border-radius: 50%;\n    border: 1px solid white;\n    width: 24rem;\n    height: 24rem;\n  }\n\n  > svg {\n    align-self: center;\n    margin-bottom: 1rem;\n  }\n"])), colorPalette.loadingOrange);
var NotifyIconWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  position: relative;\n\n  > svg {\n    margin-right: 10rem;\n  }\n"])));
var NotifyNumber = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 8rem;\n  bottom: -2rem;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 1px solid white;\n  width: 16rem;\n  height: 16rem;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12rem;\n  font-weight: bold;\n"])), colorPalette.orange);